import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  const { width = 12, height = 12 } = props;
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M6 0C2.688 0 0 2.688 0 6s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6z"
        fill="#00AB59"
      />
      <Path
        d="M4.944 8.254L3.146 6.456a.499.499 0 11.707-.706L5.3 7.192l3.445-3.445a.499.499 0 11.706.706l-3.8 3.8a.499.499 0 01-.707 0z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
